import React, {FC} from 'react';
import {downloadIcon} from '../../images/svgIcons';
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import 'react-h5-audio-player/src/styles.scss';
import './styles.scss';
interface IAudioProps {
  autoplay?: boolean;
  src: string;
  onPlay?: (e: any) => void;
  onPause?: (e: any) => void;
  onListen?: (e: any) => void;
  download?: boolean;
  showDownloadProgress?: boolean;
  onPlayError?: (e: any) => void;
}
const CusttomAudioPlayer: FC<IAudioProps> = ({
  autoplay,
  src,
  onPause,
  onPlay,
  onListen,
  download,
  showDownloadProgress,
  onPlayError,
}) => (
  <div className={`play-audio d-flex align-items-center ${src ? '' : 'disabled'}`}>
    <AudioPlayer
      autoPlay={autoplay}
      src={src}
      onPlay={onPlay}
      onPause={onPause}
      onListen={onListen}
      showDownloadProgress={showDownloadProgress}
      onPlayError={onPlayError}
    />
    {download && (
      <div className={`ml-2 cursor-pointer position-relative download-mp3 ${src ? '' : 'disabled'}`}>
        <a href={src} download>
          {downloadIcon}
        </a>
        {/* <div className="position-absolute download-mp3-hover">Download MP3</div> */}
      </div>
    )}
  </div>
);

export default CusttomAudioPlayer;
